<template>
  <v-form v-if="data" :readonly="readonly" ref="form">
    <v-card>
      <v-tabs v-model="activeTab">
        <v-tab
          v-for="(item, tabIndex) in data.gvs"
          :key="tabIndex"
          :title="item.gvsFio || '-пусто-'"
          class="font-weight-bold"
          >{{ item.gvsFio || '-пусто-' }}
        </v-tab>
        <v-tab :disabled="readonly" class="font-weight-regular">Добавить</v-tab>

        <v-tab-item
          v-for="(item, itemIndex) in data.gvs"
          :key="itemIndex"
          class="pa-2"
        >
          <v-card-text>
            <v-container fluid>
              <GvsEditor
                :fio.sync="item.gvsFio"
                :spec.sync="item.gvsSpec"
                :readonly="readonly"
                @change="
                  (fio, spec, force) => {
                    doChangeGvs(fio, spec, force, itemIndex)
                  }
                "
                @blur="doBlur()"
              />
              <v-row>
                <v-col>
                  <v-select
                    label="Наличие или целесообразность включения ЛП в КР или стандарты оказания медицинской помощи"
                    v-model.number="item.inclusionStandart"
                    :items="[0, 3]"
                    :outlined="!readonly"
                    :append-icon="editIcon"
                    type="number"
                    auto-grow
                    rows="3"
                    @input="doChange(true)"
                    @blur="doBlur()"
                  />
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <HelpCard
                    border
                    outlined
                    caption="«СПРАВОЧНАЯ ИНФОРМАЦИЯ – ОЦЕНКА ЦЕЛЕСООБРАЗНОСТИ ВКЛЮЧЕНИЯ ЛП В ПЕРЕЧНИ»"
                    class="my-2"
                  >
                    <NewFeasibility />
                  </HelpCard>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-alert v-if="needRefreshGvsScores" type="warning" dense text>
                    У части ГВС не заполнены справочные баллы из заключений.
                    Рекомендуется синхронизировать с первым ГВС
                    <template #append>
                      <v-btn
                        @click="syncGvsScoresFromReference"
                        text
                        color="green"
                        small
                        title="Синхронизировать справочные баллы у всех ГВС"
                        ><v-icon>mdi-sync</v-icon></v-btn
                      >
                    </template>
                  </v-alert>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-alert v-if="needRefresh" type="warning" dense text>
                    Внимание! Информация по критериям для данной экспертизы
                    изменилась, рекомендуется обновить данные
                    <template #append>
                      <v-btn
                        @click="refreshEO"
                        :disabled="!needRefresh"
                        text
                        color="green"
                        small
                        title="Обновить все данные по критериям"
                        ><v-icon>mdi-sync</v-icon></v-btn
                      >
                    </template>
                  </v-alert>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-alert v-if="needRefreshOtherSum" type="warning" dense text>
                    Внимание! Информация по прочим данным изменилась,
                    рекомендуется обновить данные
                    <template #append>
                      <v-btn
                        @click="refreshOtherSum"
                        :disabled="!needRefreshOtherSum"
                        text
                        color="green"
                        small
                        title="Обновить все данные по проч. данным"
                        ><v-icon>mdi-sync</v-icon></v-btn
                      >
                    </template>
                  </v-alert>
                </v-col>
              </v-row>

              <v-row v-if="editMode && fgbuError(item)">
                <v-col> </v-col>
                <v-col>
                  <check-alert
                    label="Баллы ФГБУ (доп. Данные)"
                    v-model="item.scoreFGBU"
                    :check-value="initScoreFGBU"
                    :hide-check="!editMode"
                    @change="refreshGfbu"
                  />
                </v-col>
                <v-col></v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <compare-scores
                    :value="data"
                    :item="item"
                    :readonly="readonly"
                    :edit-mode="editMode"
                    @change="
                      (data, force) => doChangeOwnScores(data, itemIndex, force)
                    "
                    @blur="doBlur"
                  />
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  <v-radio-group
                    class="mt-0 mb-4 pa-0"
                    row
                    v-model="item.conclusionExpediency"
                    @change="doChange(true)"
                  >
                    <v-radio
                      color="green"
                      :value="true"
                      label="ГВС считает ЦЕЛЕСООБРАЗНЫМ включение ЛП"
                    />
                    <v-radio
                      color="red"
                      :value="false"
                      label="ГВС считает НЕЦЕЛЕСООБРАЗНЫМ включение ЛП"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              <!-- <v-row dense>
                <v-col>
                  <v-textarea
                    label="Комментарии"
                    v-model="item.comment"
                    :outlined="!readonly"
                    @input="doChange()"
                    @blur="doBlur()"
                    hide-details
                    rows="3"
                    auto-grow
                    class="mb-1"
                    :append-icon="editIcon"
                  />
                </v-col>
              </v-row> -->
              <v-row v-for="(el, idx) in item.comments" :key="idx" dense>
                <v-col cols="12">
                  <v-textarea
                    label="Комментарии"
                    v-model="item.comments[idx]"
                    :outlined="!readonly"
                    @input="doChange()"
                    @blur="doBlur()"
                    hide-details
                    rows="3"
                    auto-grow
                    class="mb-1"
                    :append-icon="editIcon"
                  />
                </v-col>
                <v-col cols="12" class="d-flex">
                  <v-btn
                    v-if="editMode"
                    color="primary"
                    text
                    @click="
                      () => {
                        showDlg = !showDlg
                        activeIdx = idx
                        activeGvsIdx = itemIndex
                      }
                    "
                    >Шаблонные ответы</v-btn
                  >
                  <v-spacer />
                  <btn-with-confirm
                    @click="deleteComment(itemIndex, idx)"
                    :disabled="!!readonly || item.comments.length <= 1"
                    text
                    icon-main="mdi-delete"
                    title="Удалить комментарий"
                    small
                  ></btn-with-confirm>
                </v-col>

                <v-col>
                  <v-btn
                    title="Добавить комментарий"
                    v-if="idx === item.comments.length - 1"
                    color="accent"
                    fab
                    small
                    :disabled="!!readonly"
                    @click="addComment(itemIndex)"
                  >
                    <v-icon> mdi-plus </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <HelpCard
                    border
                    outlined
                    caption="СПРАВОЧНАЯ ИНФОРМАЦИЯ– БАЛЛЫ ДЛЯ РЕКОМЕНДАЦИИ К ВКЛЮЧЕНИЮ ЛП В ПЕРЕЧНИ"
                    class="my-2"
                  >
                    <RecommendScore />
                  </HelpCard>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    :value="scoreKi"
                    readonly
                    label="Балл по оценке КИ"
                    type="number"
                /></v-col>
                <v-col>
                  <v-text-field
                    :value="getScoreEP(itemIndex)"
                    readonly
                    label="Балл по оценке экономических последствий"
                    type="number"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    :value="scoreAdd(itemIndex)"
                    readonly
                    label="Балл по оценке дополнительных данных"
                    type="number"
                  />
                </v-col>
              </v-row>
              <v-row class="my-2">
                <v-col>
                  <span>Орфанный статус: </span
                  ><span class="font-weight-bold">
                    {{ data.isOrphan ? 'Да' : 'Нет' }}
                  </span>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="5">
                  <v-select
                    label="ЛП набрал рекомендованное количество баллов? "
                    :items="yesOrNo"
                    v-model="item.lpPoints"
                    :outlined="!readonly"
                    @input="doChange(true)"
                    @blur="doBlur()"
                    hide-details
                    class="mb-1"
                    :append-icon="editIcon"
                /></v-col>
                <v-col cols="7">
                  <v-textarea
                    label="По каким шкалам не набрал?"
                    v-model="item.notDidPoints"
                    :outlined="!readonly"
                    @input="doChange()"
                    @blur="doBlur()"
                    hide-details
                    class="mb-1"
                    rows="3"
                    auto-grow
                    :append-icon="editIcon"
                  />
                </v-col>
              </v-row>
              <v-row v-if="editMode">
                <v-col class="text-right">
                  <gvs-delete-dialog
                    v-if="editMode"
                    :name="item.gvsFio"
                    @onAction="deleteGvs(itemIndex)"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-tab-item>

        <!-- Последняя вкладка с добавлением -->
        <v-tab-item v-if="!readonly">
          <v-card-text>
            <v-text-field
              :label="`ГВС ФИО`"
              v-model="newGvsName"
              class="mr-4"
              style="max-width: 480px"
              :readonly="readonly"
              autofocus
            >
              <template #append-outer>
                <v-btn
                  color="primary"
                  small
                  :disabled="readonly"
                  @click="addGvs"
                >
                  Добавить
                </v-btn>
              </template>
            </v-text-field>
          </v-card-text>
        </v-tab-item>
      </v-tabs>
    </v-card>
    <OverlayGvsQuestions
      :show="showDlg"
      @close="showDlg = false"
      @add="changeComment"
    />
  </v-form>
</template>

<script>
import ExpSummaryMixin from '../ExpSummaryMixin'
import { DEFAULT_GVS_FORM } from './gvsConst'
import RecommendScore from '../scales/RecommendScore'
import HelpCard from '@/components/HelpCard'
import GvsDeleteDialog from '@/components/expSummary/summaryGVS/GvsDeleteDialog'
import GvsEditor from '@/components/expSummary/summaryGVS/GvsEditor'
import CompareScores from '@/components/expSummary/summaryGVS/scores/CompareScores'
import CheckAlert from '@/components/CheckAlert'
import { SUB_EX_ASSESSMENT, SUB_EX_OTHER } from '../../../store/const/expertise'
import NewFeasibility from '@/components/expSummary/scales/NewFeasibility'
import { mapActions } from 'vuex'
import btnWithConfirm from '@/components/buttons/btnWithConfirm'
import OverlayGvsQuestions from '../templates/OverlayGvsQuestions.vue'

export default {
  name: 'SummaryGVS',
  components: {
    CheckAlert,
    CompareScores,
    GvsEditor,
    NewFeasibility,
    GvsDeleteDialog,
    RecommendScore,
    HelpCard,
    btnWithConfirm,
    OverlayGvsQuestions,
  },
  data: () => ({
    yesOrNo: ['Да', 'Нет'],
    activeTab: 0,
    newGvsName: '',
    loading: false,
    initEO: 0,
    initFEO: 0,
    initOtherSum: 0,
    error: '',
    showDlg: false,
    activeIdx: null,
    activeGvsIdx: null,
  }),
  watch: {
    gvs: {
      handler() {
        this.reInit()
      },
    },
  },
  mixins: [ExpSummaryMixin],
  async mounted() {
    this.loading = true
    try {
      const { expertise } = await this.GET_PLP_REPORT([
        SUB_EX_ASSESSMENT,
        SUB_EX_OTHER,
      ])

      // this.initEO = expertise?.assessment?.scoreEO || 0
      this.initEO = expertise?.assessment?.maxValue || 0
      this.initFEO = this.getMaxValue(expertise?.assessment?.economic || [])

      this.initOtherSum = expertise?.other?.sum || 0
    } catch (err) {
      this.error = `${err.message} ${err.error}`.trimEnd()
      throw err
    } finally {
      this.loading = false
    }
    this.syncGvsScoresFromReference()
    this.reInit()
  },
  computed: {
    gvs() {
      return this.data?.gvs || {}
    },
    initScoreFGBU() {
      return this.initData?.other?.sum || 0
    },
    lastGvs() {
      return this.data.gvs?.length - 1 || 0
    },
    scoreKi() {
      return this.data?.assessmentOrganization?.qualityAssessment?.scoreEO || 0
    },
    scoreEconomic() {
      return this.data?.assessmentOrganization?.economicAssessment?.scoreEO || 0
    },
    needRefresh() {
      return (
        this.data?.gvs[0]?.initEO !== this.initEO ||
        this.data?.gvs[0]?.initFEO !== this.initFEO
      )
    },
    needRefreshOtherSum() {
      return this.data?.gvs[0]?.initOtherSum !== this.initOtherSum
    },
    needRefreshGvsScores() {
      if ((this.data?.gvs?.length || 0) <= 1) return false
      const ref = this.getGvsScoreReference()
      return this.data.gvs.some(
        (item, idx) => idx > 0 && this.gvsItemOutOfSyncWithReference(item, ref)
      )
    },
  },
  methods: {
    ...mapActions(['GET_PLP_REPORT']),
    getGvsScoreReference() {
      const first = this.data?.gvs?.[0]
      return {
        initEO: Number(first?.initEO || this.initEO || 0),
        initFEO: Number(first?.initFEO || this.initFEO || 0),
        initOtherSum: Number(first?.initOtherSum ?? this.initOtherSum ?? 0),
        scoreFGBU: Number(first?.scoreFGBU ?? this.initScoreFGBU ?? 0),
      }
    },
    gvsItemOutOfSyncWithReference(item, reference) {
      const ref = reference || this.getGvsScoreReference()
      return (
        Number(item?.initEO || 0) !== ref.initEO ||
        Number(item?.initFEO || 0) !== ref.initFEO ||
        Number(item?.initOtherSum || 0) !== ref.initOtherSum ||
        Number(item?.scoreFGBU || 0) !== ref.scoreFGBU
      )
    },
    applyGvsScoreReference(item, reference) {
      const ref = reference || this.getGvsScoreReference()
      item.initEO = ref.initEO
      item.initFEO = ref.initFEO
      item.initOtherSum = ref.initOtherSum
      item.scoreFGBU = ref.scoreFGBU
    },
    applyExpertiseScoresToGvsItem(item) {
      this.applyGvsScoreReference(item, {
        initEO: this.initEO,
        initFEO: this.initFEO,
        initOtherSum: this.initOtherSum,
        scoreFGBU: this.initScoreFGBU,
      })
    },
    syncGvsScoresFromReference() {
      const ref = this.getGvsScoreReference()
      let changed = false
      this.data?.gvs?.forEach((item, idx) => {
        if (idx === 0) return
        if (!this.gvsItemOutOfSyncWithReference(item, ref)) return
        this.applyGvsScoreReference(item, ref)
        changed = true
      })
      if (changed) this.doChange(true)
    },
    refreshEO() {
      this.data.gvs.forEach(item => {
        item.initEO = this.initEO
        item.initFEO = this.initFEO
      })

      this.doChange(true)
    },
    deleteComment(gvsIndex, idx) {
      this.data.gvs[gvsIndex].comments.splice(idx, 1)

      this.doChange(true)
    },
    addComment(index) {
      this.data.gvs[index].comments.push('')
      this.doChange(true)
    },
    refreshOtherSum() {
      this.data.gvs.forEach(item => {
        item.initOtherSum = this.initOtherSum
      })

      this.doChange(true)
    },
    addGvs() {
      const newGvs = DEFAULT_GVS_FORM()
      newGvs.gvsFio = this.newGvsName
      this.applyGvsScoreReference(newGvs)
      this.data.gvs.push(newGvs)
      this.newGvsName = ''
      this.activeTab = this.lastGvs + 1
      this.doChange(true)
    },
    deleteGvs(itemIndex) {
      this.data?.gvs?.splice(itemIndex, 1)
      this.activeTab = itemIndex - 1 || 0
      this.doChange(true)
    },
    onCloseTemplate() {
      this.showDlg = false
    },
    refreshGfbu() {
      this.data.gvs.forEach(item => (item.scoreFGBU = this.initScoreFGBU))
      this.doChange(true)
    },
    fgbuError(item) {
      return item.scoreFGBU !== this.initScoreFGBU && !this.logView
    },
    doChangeGvs(fio, spec, force, itemIndex) {
      this.data.gvs[itemIndex].gvsFio = fio
      this.data.gvs[itemIndex].gvsSpec = spec
      this.doChange(force)
    },
    doChangeOwnScores(data, idx, force) {
      this.data.gvs[idx].ownScores = data
      this.doChange(force)
    },
    getScoreFGBU(itemIndex) {
      return this.data?.gvs[itemIndex].scoreFGBU || 0
    },
    scoreAdd(itemIndex) {
      return (
        this.getScoreFGBU(itemIndex) +
        this.data?.gvs[itemIndex].inclusionStandart
      )
    },
    getScoreEP(itemIndex) {
      return this.data?.gvs[itemIndex].initFEO || 0
    },
    getMaxValue(economic) {
      if (!economic?.length) return 0
      return Math.max(...economic.map(item => item.resultScore)) || 0
    },
    changeComment(comment) {
      this.data.gvs[this.activeGvsIdx].comments[this.activeIdx] = String(
        this.data.gvs[this.activeGvsIdx].comments[this.activeIdx].trimRight() +
          '\n' +
          comment
      ).trim()

      this.doChange(true)
    },
  },
}
</script>
